import { desaturate } from 'polished';
import styled from 'styled-components';

export const Container = styled.div<{ active?: boolean }>`
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  direction: ltr;
  gap: 5px;
  padding: 5px;
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme, active }) =>
    active ? theme.colors.info : desaturate(1, theme.colors.info)};
`;

export const Label = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textInfo};
`;

export const Turma = styled.div<{ active?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 2px 5px;
  font-size: 12px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  background-color: ${({ theme, active }) =>
    active ? theme.colors.success : desaturate(1, theme.colors.success)};
  color: ${({ theme }) => theme.colors.textSuccess};
`;
